import React from 'react';

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className = "w-10 h-10" }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 100 100" 
      className={className}
      aria-label="TruckLoad 3D Logo"
      role="img"
      fill="none"
    >
      <defs>
        <filter id="soft-shadow" x="-50%" y="-50%" width="200%" height="200%">
          <feDropShadow dx="0" dy="4" stdDeviation="4" floodColor="#000" floodOpacity="0.25" />
        </filter>
      </defs>

      <g filter="url(#soft-shadow)">
        {/* Top Face - Yellow - Represents Y Axis / Height or Top View */}
        <path 
          d="M50 15 L85 35 L50 55 L15 35 Z" 
          fill="#fbbf24" 
          stroke="#d97706" 
          strokeWidth="1"
          strokeLinejoin="round"
        />
        
        {/* Right Face - Red - Represents X Axis */}
        <path 
          d="M50 55 L85 35 L85 75 L50 95 Z" 
          fill="#ef4444" 
          stroke="#b91c1c" 
          strokeWidth="1"
          strokeLinejoin="round"
        />
        
        {/* Left Face - Blue - Represents Z Axis */}
        <path 
          d="M15 35 L50 55 L50 95 L15 75 Z" 
          fill="#3b82f6" 
          stroke="#1d4ed8" 
          strokeWidth="1"
          strokeLinejoin="round"
        />
        
        {/* Inner Highlight Lines for 3D effect */}
        <path d="M50 55 L50 95" stroke="#1e293b" strokeWidth="1" strokeOpacity="0.1" />
        <path d="M15 35 L50 55" stroke="#1e293b" strokeWidth="1" strokeOpacity="0.1" />
        <path d="M85 35 L50 55" stroke="#1e293b" strokeWidth="1" strokeOpacity="0.1" />
      </g>
    </svg>
  );
};

export default Logo;